export { CNAnimatedBanner } from './CNAnimatedBanner';
